import { IconButton, styled } from '@mui/material'
import { alpha, darken } from '@mui/material/styles'
import BurgerIcon from '@mui/icons-material/Menu'

const DEFAULT_FAIRTRADE_BG = '#DBFF4C'
const DEFAULT_FAIRTRADE_TEXT = '#111111'

export const MenuWrapper = styled('div') <{ topOffset?: number }>`
  position: absolute;
  top: ${({ topOffset = 0 }) => `${20 + topOffset}px`};
  left: 20px;
  z-index: 20;
`

export const MenuIconButton = styled(IconButton) <{
  variant?: string
  backgroundColor?: string
  textColor?: string
}>`
  padding: ${({ variant }) => (variant === 'fairtrade' ? '9px' : '8px')};
  ${({ theme, variant }) =>
    variant === 'fairtrade'
      ? `
        ${theme.breakpoints.down('sm')} {
          padding: 5px;
        }
      `
      : ''}
  color: ${({ theme, textColor, variant }) =>
    variant === 'fairtrade' ? textColor || DEFAULT_FAIRTRADE_TEXT : theme.palette.common.white};
  background-color: ${({ variant, backgroundColor }) =>
    variant === 'fairtrade' ? backgroundColor || DEFAULT_FAIRTRADE_BG : 'transparent'};
  border-radius: ${({ variant }) => (variant === 'fairtrade' ? '0px' : '50%')};
  box-shadow: ${({ variant }) =>
    variant === 'fairtrade' ? '0px 6px 20px rgba(0,0,0,0.15)' : 'none'};
  transition: background-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: ${({ variant, backgroundColor }) =>
    variant === 'fairtrade'
      ? darken(backgroundColor || DEFAULT_FAIRTRADE_BG, 0.05)
      : 'rgba(255,255,255,0.08)'};
    box-shadow: ${({ variant, backgroundColor }) =>
    variant === 'fairtrade'
      ? `0px 10px 24px ${alpha(backgroundColor || DEFAULT_FAIRTRADE_TEXT, 0.2)}`
      : 'none'};
  }
`

export const MenuIcon = styled(BurgerIcon) <{ variant?: string }>`
  && {
    border-radius: ${({ variant }) => (variant === 'fairtrade' ? '0px' : '50%')};
    padding: ${({ theme, variant }) => (variant === 'fairtrade' ? 0 : theme.spacing(0.6))};
    background-color: ${({ variant }) =>
    variant === 'fairtrade' ? 'transparent' : 'rgba(0, 0, 0, 0.4)'};

    width: ${({ variant }) => (variant === 'fairtrade' ? '22px' : '30px')};
    height: ${({ variant }) => (variant === 'fairtrade' ? '22px' : '30px')};
    fill: currentColor;
  }
`
